import { render, staticRenderFns } from "./SelectSingle.vue?vue&type=template&id=2d52f676"
import script from "./SelectSingle.vue?vue&type=script&lang=js"
export * from "./SelectSingle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports